export const BILLING_CONSTANTS = {
  TRIAL_DAYS: 0,
  URL_PARAMS: {
    MONTHLY: 'monthly' as const,
    YEARLY: 'yearly' as const,
  },
  INTERVALS: {
    MONTH: 'month' as const,
    YEAR: 'year' as const,
  },
  PLANS: {
    FREE: {
      price: 0,
      interval: null,
      label: 'Gratis',
      limit: 5,
    },
    PRO_MONTHLY: {
      price: 8.99,
      interval: 'month' as const,
      label: 'PRO Maandelijks',
    },
    PRO_YEARLY: {
      price: 99,
      interval: 'year' as const,
      label: 'PRO Jaarlijks',
      savings: 8.88,
    },
  },
  MESSAGES: {
    TRIAL_WELCOME: '30 dagen gratis proberen',
    TRIAL_AUTO_RENEW: 'Je wordt automatisch overgeschakeld naar PRO na de proefperiode',
    TRIAL_CANCEL_ANYTIME: 'Je kunt altijd annuleren tijdens de proefperiode',
    TRIAL_ENDING_SOON: 'Je proefperiode eindigt binnenkort',
    TRIAL_ENDING_TODAY: 'Je proefperiode eindigt vandaag',
    TRIAL_DAYS_REMAINING: (days: number) => `${days} ${days === 1 ? 'dag' : 'dagen'} proefperiode resterend`,
    TRIAL_INFO_LONG: 'Geniet van alle PRO functies tijdens je gratis proefperiode.',
    TRIAL_INFO_SHORT:
      'Je wordt automatisch overgeschakeld naar PRO (€8,99/maand) na je proefperiode, tenzij je annuleert.',
    READ_ONLY_TITLE: 'Gratis Tier',
    READ_ONLY_INFO:
      'Je hebt 3 gratis documenten per maand. ' +
      'Upgrade naar PRO voor onbeperkte facturen en offertes.',
    UPGRADE_CTA: 'Upgrade naar PRO',
    UPGRADE_CTA_SETTINGS: 'Bekijk Abonnement',
    PRO_REQUIRED: 'Deze functie is alleen beschikbaar voor PRO leden',
    START_TRIAL: 'Upgrade naar PRO',
    CANCEL_SUBSCRIPTION: 'Abonnement Opzeggen',
    RESUME_SUBSCRIPTION: 'Abonnement Hervatten',
    MANAGE_PAYMENT: 'Beheer Betaalmethode',
    CANCEL_CONFIRMATION_TITLE: 'Abonnement Opzeggen?',
    CANCEL_CONFIRMATION_TRIAL: (date: string) =>
      `Je behoudt toegang tot alle PRO functies tot ${date}. ` +
      'Daarna keer je terug naar de gratis tier (3 documenten per maand).',
    CANCEL_CONFIRMATION_PAID: (date: string) =>
      `Je behoudt toegang tot alle PRO functies tot ${date}. ` +
      'Daarna keer je terug naar de gratis tier (3 documenten per maand).',
    CANCEL_CONFIRMATION_NOTE: 'Je kunt altijd opnieuw upgraden naar PRO.',
    CANCEL_SUCCESS: (date: string) => `Je abonnement is geannuleerd. Je behoudt toegang tot ${date}`,
    PRO_TRIAL_TITLE: 'PRO Proefperiode',
    PRO_SUBSCRIPTION_TITLE: 'PRO Abonnement',
    TRIAL_ENDS_AT: (days: string) => `Nog ${days} dagen`,
    ACTIVE_SINCE: (date: string) => `Actief sinds ${date}`,
    TRIAL_AUTO_CHARGE: (date: string, price: string, interval: string) =>
      `Je proefperiode eindigt op ${date}. Daarna wordt je automatisch overgeschakeld naar ${price}/${interval}.`,
    STATUS_LABEL: 'Status:',
    PLAN_LABEL: 'Plan:',
    PRICE_LABEL: 'Prijs:',
    SUBSCRIPTION_ENDING: (date: string) => `Je hebt PRO toegang tot ${date}.`,
    GRACE_PERIOD_NOTE: 'Daarna keer je terug naar de gratis tier (3 documenten per maand).',
    MONTHLY_LABEL: 'Maandelijks',
    YEARLY_LABEL: 'Jaarlijks',
    PRICE_MONTHLY: '€ 8,99/maand',
    PRICE_YEARLY: '€ 99/jaar',
    SAVINGS_LABEL: 'Bespaar € 8,88',
    COUPON_LABEL: 'Kortingscode (optioneel)',
    COUPON_HELPER: 'Vul een kortingscode in om korting te krijgen',
    COUPON_INVALID: 'Ongeldige kortingscode',
  },
  FEATURES: {
    PRO: [
      'Onbeperkt facturen en offertes',
      'E-mail verzending met templates',
      'PDF branding met je eigen logo',
      'KVK en BTW validatie',
      'Uitgebreide analytics',
    ],
  },
  LABELS: {
    UPGRADE_TITLE: 'Upgrade naar PRO',
    WHAT_YOU_GET: 'Wat krijg je met PRO?',
    TRIAL_INFO_TITLE: 'Direct toegang tot PRO',
    TRIAL_INFO_DESCRIPTION: (price: string, interval: string) =>
      'Je krijgt direct toegang tot alle PRO functies. ' +
      `Je betaalt €${price}/${interval}. ` +
      'Je kunt altijd annuleren.',
    CHOOSE_PLAN: 'Kies je abonnement',
    USAGE_STATS: 'Gebruiksstatistieken',
    USAGE_PERIOD: 'Deze maand',
    DOCUMENTS_SENT: 'Aangemaakte documenten:',
    UNLIMITED_DOCUMENTS: 'Je kunt onbeperkt documenten aanmaken met PRO',
    UPGRADE_TO_SEND: 'Upgrade naar PRO om weer documenten aan te maken',
  },
  ERRORS: {
    FAILED_LOAD_STATUS: 'Kan abonnementsstatus niet laden',
    FAILED_LOAD_PLANS: 'Kan abonnementen niet laden',
    FAILED_CREATE_CHECKOUT: 'Kan checkout niet starten',
    FAILED_CANCEL_SUBSCRIPTION: 'Kan abonnement niet opzeggen',
    FAILED_RESUME_SUBSCRIPTION: 'Kan abonnement niet hervatten',
    FAILED_LOAD_INVOICES: 'Kan facturen niet laden',
  },
} as const
